module.exports = __WEBPACK_EXTERNAL_MODULE_43__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/menu/dist/mdc.menu","commonjs2":"@material/menu/dist/mdc.menu","commonjs":"@material/menu/dist/mdc.menu","amd":"@material/menu/dist/mdc.menu","umd":"@material/menu/dist/mdc.menu"}
// module id = 43
// module chunks = 0